import { ApiKeyListItemSchema, ZodCreateApiKeySchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type ApiKey = ApiKeyListItemSchema;

export const getApiKeys = async (): Promise<ApiKey[]> => {
  const response = await apiClient.get<{ apiKeys: ApiKey[] }>("/api/api-keys");
  return response.data.apiKeys;
};

export const getApiKey = async (keyId: string): Promise<ApiKey> => {
  const response = await apiClient.get<{ apiKey: ApiKey }>(`/api/api-keys/${keyId}`);
  return response.data.apiKey;
};

export const createApiKey = async (
  data: ZodCreateApiKeySchema,
): Promise<{ apiKey: string; key: { id: string; name: string; keyPrefix: string }; message: string }> => {
  const response = await apiClient.post<{
    apiKey: string;
    key: { id: string; name: string; keyPrefix: string };
    message: string;
  }>("/api/api-keys", data, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const revokeApiKey = async (keyId: string): Promise<{ message: string }> => {
  const response = await apiClient.delete<{ message: string }>(`/api/api-keys/${keyId}`);
  return response.data;
};
